import '@atlaskit/css-reset';
import React, { memo } from 'react';
import AppBase from '@atlassian/jira-app-base';
import PolarisUnlicensedApp from '@atlassian/jira-polaris-apps-unlicensed';
import { withRouter } from '@atlassian/jira-router';
import { SubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product';
import { AuthenticationCheck } from '@atlassian/jira-spa-apps-common/src/interceptors/authentication';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller';

const PolarisUnlicensedPageContentInternal = () => <PolarisUnlicensedApp />;

const PolarisUnlicensedPageContent = memo(PolarisUnlicensedPageContentInternal);

export const PolarisUnlicensedPage = () => (
	<>
		<MarkProductStart />
		<AuthenticationCheck>
			<AppBase id="polaris-unlicensed">
				<SubProductUpdater subProduct="polaris" />
				<PolarisUnlicensedPageContent />
				<SpaStatePageReady />
			</AppBase>
		</AuthenticationCheck>
	</>
);

export default withRouter(PolarisUnlicensedPage);
